import { render, staticRenderFns } from "./ModuleNotEnabled.vue?vue&type=template&id=0c17979c&lang=html&"
import script from "./ModuleNotEnabled.vue?vue&type=script&lang=js&"
export * from "./ModuleNotEnabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports